import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'peripheralDevice',
	friendly_name: 'Peripheral Device',
	family: 'peripheral',
	modes: {
		sensor: {
			channels: 1,
			settings: [
				webhooks_gen_2,
				{
					title: 'sensor_settings',
					components: [
						{
							title: 'peripheral_device_settings',
							component: 'peripheral_device_settings',
						},
					],
				},
				{
					title: 'application_settings',
					components: [],
				},
				share,
				{
					title: 'settings',
					components: [
						{
							title: 'device_information',
							component: 'device_information',
						},
					],
				},
			],
		},
		relay: {
			channels: 1,
			settings: [
				{
					title: 'timer',
					icon: 'far fa-clock',
					components: [
						{
							title: 'auto',
							component: 'auto_gen_2',
						},
					],
				},
				schedule_gen_2,
				webhooks_gen_2,
				{
					title: 'sensor_settings',
					components: [
						{
							title: 'peripheral_device_settings',
							component: 'peripheral_device_settings',
						},
					],
				},
				share,
				{
					title: 'settings',
					components: [
						{
							title: 'device_information',
							component: 'device_information',
						},
					],
				},
			],
		},
		lora: {
			channels: 1,
			settings: [
				{
					title: 'application_settings',
					components: [
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
					],
				},
				share,
				{
					title: 'settings',
					components: [
						{
							title: 'device_information',
							component: 'device_information',
						},
					],
				},
			],
		},
	},
};
